// Cor do card por prioridade da trigger no Zabbix (0 não classificada a 5 desastre)
const COR_POR_PRIORIDADE = {
  0: "blue",
  1: "blue",
  2: "yellow",
  3: "orange",
  4: "red",
  5: "red",
};

// Cor neutra: item sem trigger configurada ou status indisponível
const COR_NEUTRA = "blue";

// Cor quando o item tem trigger e nenhuma está disparada
const COR_OK = "green";

/**
 * Cor do card a partir do status das triggers do item (/zabbix/triggers/status).
 *
 * @param {Object} statusItem - { possuiTrigger, prioridade, problemas }
 * @returns {string} Chave de cor de theme.palette.cardGraphic
 */
export default function corPorTrigger(statusItem) {
  // Sem status ou sem trigger configurada: não há regra para dizer que está ok
  if (!statusItem?.possuiTrigger) return COR_NEUTRA;

  // Tem trigger e nenhuma disparada
  if (statusItem?.prioridade === null || statusItem?.prioridade === undefined) {
    return COR_OK;
  }

  return COR_POR_PRIORIDADE?.[statusItem?.prioridade] || COR_NEUTRA;
}
